import Swal from 'sweetalert2'
import customSelect from 'custom-select'

export default () => {
  const phoneInput = document.querySelector('.phone-mask')

  if (phoneInput) {
    phoneInput.addEventListener('input', event => {
      const x = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,4})(\d{0,4})/)
      event.target.value = '+(' + x[1] + ') ' + x[2] + '-' + x[3] + '-' + x[4]
    })
  }

  customSelect(document.querySelectorAll('.js-property-type-select'))
  customSelect(document.querySelector('.js-filter-sotring'))
  document.querySelectorAll('.js-state-code-select').forEach(select => {
    customSelect(select)
  })

  $('.js-delete-property').on('click', function () {
    const propertyID = $(this).closest('.property').attr('data-property-id')

    Swal.fire({
      title: 'Do you want to delete the property?',
      confirmButtonText: 'Yes, delete',
      showCancelButton: true,
      showClass: {popup: ''},
      hideClass: {popup: ''}
    }).then(result => {
      if (result.isConfirmed) {
        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          type: 'POST',
          data: {
            action: 'deleteProperty',
            data: propertyID
          },
          beforeSend: () => {
            Swal.fire({
              html: `
                <svg style="margin: auto; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="3" r="12" stroke-dasharray="56.548667764616276 20.84955592153876">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                  </circle>
                </svg>
              `,
              showConfirmButton: false,
              showClass: {popup: ''},
              hideClass: {popup: ''}
            })
          },
          success: response => {
            if (response.data.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Your property has been deleted successfully!',
                showConfirmButton: false,
                timer: 1500
              })
              window.location = window.location.pathname + '?isProfileTab=true'
            } else {
              console.log(response)
              Swal.fire({
                icon: 'warning',
                title: 'Something went wrong!',
                text: 'Try again later.',
                showConfirmButton: false,
                timer: 1500
              })
            }
          },
          error: error => {
            console.log(error)
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong!',
              text: 'Try again later.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
      }
    })
  })
}
